import { clamp } from 'lodash-es';
import { useRef } from 'react';
import { filter, fromEvent, map, tap } from 'rxjs';

import { useSubscriptions } from '@/package';
import { useTaskFrameStore } from '@/store';
import { withTarget } from '@/util';

import ToolPlayControllerFrameBarTickerList from './ToolPlayControllerFrameBarTickerList';
import { CLASSNAME, ZOOM } from './constant';
import useToolPlayControllerContext from './useToolPlayControllerContext';

const ToolPlayControllerFrameBar = () => {
  const { allFrameListLength, zoom, moveFrameSeq, setZoom, isPlaying, stop } =
    useToolPlayControllerContext();
  const { selectedTask } = useTaskFrameStore();

  const frameBarEl = useRef<HTMLDivElement>(null);
  // NOTE: 백엔드에서 startFrameSeq과 endFrameSeq이 0인 경우 지정하지 않은 것으로 간주
  const activeRange =
    selectedTask?.startFrameSeq && selectedTask.endFrameSeq
      ? ([selectedTask.startFrameSeq, selectedTask.endFrameSeq] as [
          number,
          number,
        ])
      : undefined;

  useSubscriptions(
    () => [
      fromEvent<WheelEvent>(window, 'mousewheel')
        .pipe(
          withTarget,
          filter(
            e =>
              e.target === frameBarEl.current ||
              e.target.closest(`.${CLASSNAME.FRAMEBAR.get()}`) ===
                frameBarEl.current,
          ),
          filter(e => !e.shiftKey),
          map(e => (e.deltaY < 0 ? 1 : e.deltaY > 0 ? -1 : 0)),
          tap(value => {
            setZoom(
              zoom =>
                clamp(zoom + value, ZOOM.MIN, ZOOM.MAX) as typeof ZOOM.DEFAULT,
            );
          }),
        )
        .subscribe(),
    ],
    [zoom],
  );

  return (
    <div
      ref={frameBarEl}
      aria-label="tool-play-controller-frame-bar"
      className={CLASSNAME.FRAMEBAR.get()}
      data-all-frame-list-length={allFrameListLength}
    >
      <ToolPlayControllerFrameBarTickerList
        activeRange={activeRange}
        onChange={newIndex => {
          if (isPlaying) stop();

          moveFrameSeq(newIndex + 1);
        }}
      />
    </div>
  );
};

export default ToolPlayControllerFrameBar;
